import { mapMutations } from "vuex";

export default {
  methods: {
    ...mapMutations("setting", ["OPEN_ZEN_MODE", "CLOSE_ZEN_MODE"])
  },
  mounted() {
    this.OPEN_ZEN_MODE();
  },
  beforeDestroy() {
    this.CLOSE_ZEN_MODE();
  }
};
